import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import {
  completeBibliographicStep,
  setStepBibliographicEdited,
} from "../../../../../../store/redux/slice/Forms/biblioReferenceForm";
import { toast } from "react-toastify";
import { ApplicationSubtype, BoxSpg, DividerSpg } from "@duosoftbg/nacid-components";
import { Button, Typography } from "@mui/material";
import BibliographicReferenceDetailsFormSection from "./section/BibliographicReferenceDetailsFormSection";
import { createBiblioReferenceDetailsValidationSchema } from "../../../../../../yup/bibliographicReference/biblioReferenceValidationSchemas";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import { initialBibliographicReferenceDetails } from "../../../../../../init/biblioReferenceInitialValues";
import useFormReset from "../../../../../../hooks/useFormReset";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";

const BiblioReferenceStepBibliographic = () => {
  const { t } = useTranslation();

  const biblioReferenceForm = useAppSelector((state) => {
    return state.Forms.BiblioReferenceForm;
  });

  const fullSchema = createBiblioReferenceDetailsValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    biblioReferenceForm.bibliographicReferenceDetails,
    biblioReferenceForm.id,
    baseEndpointPaths.bibliographicReference,
    formalSchema,
    setStepBibliographicEdited,
    completeBibliographicStep,
    initialBibliographicReferenceDetails,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.BIBLIO_REFERENCE, biblioReferenceForm.bibliographicReferenceDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
            console.log(errors);
          })}
        >
          <BibliographicReferenceDetailsFormSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default BiblioReferenceStepBibliographic;
